import React from 'react';
import { StyleSheet, View, Text } from 'react-native';
import Colors from '../constants/Colors';
import isMobile from './IsMobile';

const PasswordHints = () => <View style={styles.container}>
  <View style={styles.section}>
    <View style={styles.item}>
      <View style={styles.dot} />
      <Text style={styles.text}>{'At least 8 characters'}</Text>
    </View>
    <View style={styles.item}>
      <View style={styles.dot} />
      <Text style={styles.text}>{'At least 1 lowercase character'}</Text>
    </View>
  </View>
  <View style={styles.section}>
    <View style={styles.item}>
      <View style={styles.dot} />
      <Text style={styles.text}>{'At least 1 uppercase character'}</Text>
    </View>
    <View style={styles.item}>
      <View style={styles.dot} />
      <Text style={styles.text}>{'At least 1 numeric digit'}</Text>
    </View>
  </View>
  <View style={styles.section}>
    <View style={styles.item}>
      <View style={styles.dot} />
      <Text style={styles.text}>{'At least 1 special character'}</Text>
    </View>
  </View>
</View>;

const styles = StyleSheet.create({
  container: {
    alignSelf: 'stretch',
    marginTop: 4,
  },
  section: {
    flexDirection: isMobile ? 'column' : 'row',
  },
  item: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    marginTop: 8,
  },
  dot: {
    backgroundColor: Colors.light.hereworksBlue500,
    borderRadius: 100,
    width: 4,
    aspectRatio: 1,
    marginEnd: 8,
  },
  text: {
    fontSize: 12,
    lineHeight: 16,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack400,
    letterSpacing: 0.15,
  },
});

export default PasswordHints;
